import React from 'react';

export type MiniBar = { value: number; label?: string };

/**
 * Barres SVG dessinées à la main (zéro dépendance externe). Prend un number[]
 * (ou {value,label}[]) et rend des barres verticales normalisées sur le max.
 * Style refonte : barres rose Hook, socle discret.
 */
const MiniBars: React.FC<{
  data: Array<number | MiniBar>;
  height?: number;
  barColor?: string;
  className?: string;
}> = ({ data, height = 48, barColor = '#E91E8C', className = '' }) => {
  const bars: MiniBar[] = data.map(d => (typeof d === 'number' ? { value: d } : d));
  const max = Math.max(1, ...bars.map(b => b.value));
  const gap = 4;
  const barW = 14;
  const width = bars.length > 0 ? bars.length * barW + (bars.length - 1) * gap : barW;

  if (bars.length === 0) {
    return <p className="text-[11px] text-faint font-mono">Aucune donnée</p>;
  }

  return (
    <svg
      width="100%"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      role="img"
      aria-label={`Graphique en barres, ${bars.length} valeurs`}
      className={className}
    >
      {bars.map((b, i) => {
        const h = Math.max(2, (b.value / max) * (height - 2));
        const x = i * (barW + gap);
        const y = height - h;
        return (
          <g key={i}>
            <rect x={x} y={0} width={barW} height={height} rx={2} fill={barColor} opacity={0.08} />
            <rect x={x} y={y} width={barW} height={h} rx={2} fill={barColor}>
              {b.label && <title>{`${b.label} : ${b.value}`}</title>}
            </rect>
          </g>
        );
      })}
    </svg>
  );
};

export default MiniBars;
